import React from 'react';

import { Typography } from '@mui/material';
import { SelectButton } from 'src/components';
import { InsertImageIcon } from 'src/components/icons/InsertImageIcon';
import { imageDialogStateVar } from 'src/editor/AlineEditor';
import { useEditingDisabled } from 'src/store/document/selectors';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  imageText: {
    marginLeft: theme.spacing(0.5),
  },
}));

export function InsertImageButton(): JSX.Element {
  const { classes } = useStyles();
  const disabled = useEditingDisabled();

  return (
    <>
      <SelectButton disabled={disabled} onClick={() => imageDialogStateVar({ open: true })}>
        <InsertImageIcon />
        <Typography className={classes.imageText} color="inherit" variant="caption">
          Image
        </Typography>
      </SelectButton>
    </>
  );
}
